<!-- App.svelte -->

<script>
    import { navigateTo } from 'svelte-router-spa'
    import TodoItem from "./components/TestItem.svelte";
    import { mmti_dict, pv } from "./store";

    let todos = [
        { id: 25, text: "혼자 놀 때 보다 다른 개(사람)과 어울릴 때 더 신나합니다", opacity: 1.0 },
        { id: 26, text: "당신의 반려견은 간낳괴(간식이 낳은 괴물, 간식이 없다면 명령하지도 마라 상태)입니다. ", opacity: 1.0 },
        { id: 27, text: "아무리 장난을 쳐도 화내는 법이 없습니다.", opacity: 1.0 },
        { id: 28, text: "종종 멍을 때리고 있습니다", opacity: 1.0 },
        { id: 29, text: "당신은 반려견과 산책을 나갔을 때 산책을 당하는 편입니다.", opacity: 1.0 },
        { id: 30, text: "다른 개들과 만나서 놀기보다는 혼자 조용히 도그채널을 보거나 명상을 하길 좋아합니다.", opacity: 1.0 },
        { id: 31, text: "삐져있다가도 당신이 무반응이면 다시 와서 당신의 눈치를 살핍니다.", opacity: 1.0 },
        { id: 32, text: "다른 개들과 놀 때 놀이를 주도하는 편입니다.", opacity: 0.0 },
    ];

    $pv = 24;
    let i = 0;
    let test_id = '';
    for (i = 0; i < todos.length; i++) {
        test_id = 'mmti' + String(todos[i].id)
        if (test_id in $mmti_dict) {
            $pv += 1;
        }
    } 


    function clickContinue() {
        let allPass = true;

        for (let i = 0; i < todos.length; i++) {
            let todo = todos[i];
            let test_id = 'mmti' + String(todo.id);

            if (test_id in $mmti_dict) {
                todos[i]['textColor'] = 'black';
                todos[i]['textAni'] = '';
            } else {
                allPass = false;
                todos[i]['textColor'] = '#ad1305';
                todos[i]['textAni'] = 'text_shake';

                setTimeout(function(){
                    todos[i]['textAni'] = '';
                }, 500);
            }
        }

        if (allPass) {
            navigateTo('test5');
        } else {
            alert('체크 안 한 항목이 있는지 한 번 더 확인해주세요.');
        } 
    }

</script>

<style lang="scss">
.hero-body {
    background: #f5f5f6;   
}

body, html {
    -webkit-tap-highlight-color: transparent; 
}
.progress {
  border-radius: 0;
}

.progress.is-mmti::-webkit-progress-value {
  background-color: rgba($color: #36765a, $alpha: 1.0);
}

.progress.is-mmti::-moz-progress-bar {
  background-color:rgba($color: #36765a, $alpha: 1.0);
}

.progress.is-mmti::-ms-fill {
  background-color:rgba($color: #36765a, $alpha: 1.0);
}

.progress.is-mmti:indeterminate {
  background-image: linear-gradient(to right, rgba($color: #36765a, $alpha: 1.0) 30%, #ededed 30%);
}

</style>

<html class="has-navbar-fixed-top" style="padding-top: 0">

<nav class="navbar is-fixed-top" style="background: #f5f5f6; min-height: 0;">
<progress class="progress is-mmti" value="{$pv}" max="40"></progress>
</nav>

<body>
<section class="hero is-fullheight">
<div class="hero-body">
<div class="container has-text-centered">
<div class="columns is-desktop">

    <div class="column">

    {#each todos as todo (todo.id)}
    <TodoItem {todo} />
    {/each}

    <div class="container">
    <figure class="image container is-128x128" style="width: 150px; cursor: pointer;" on:click={() => clickContinue() }><img src="/next.png">
    <h1 class ="title is-6 is-overlay mt-4 mr-5 has-text-white"><p>다음</p></h1>
    </figure>
    </div>

</div>
</div>
</div>
</section>
</body>
</html>
